import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { PurchaseInvoice } from 'src/app/@shared/models/purchasing/invoice/purchase-invoice.model';


const CLASS_NAME = 'PurchaseInvoice';
const ENDPOINT = `/purchase-invoices/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'account-entries', path: 'account-entries/', childClass: 'AccountEntryLine' },
    { key: 'potential-settlements', path: 'potential-settlements/', childClass: 'Settlement' },
    { key: 'settlements', path: 'settlements/', childClass: 'Settlement' },
]
const ROUTES: RouteParam[] = [
    { key: 'abandonOcr', path: '{id}/abandon-ocr/' },
    { key: 'confirmIsInvoice', path: '{id}/confirm-is-invoice/' },
    { key: 'devalidate', path: '{id}/devalidate/' },
    { key: 'downloadFile', path: '{id}/pdf/' },
    { key: 'export', path: 'export/' },
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'massDownload', path: 'mass-download/' },
    { key: 'proposeAllocations', path: '{id}/propose-allocations/' },
    { key: 'replaceFile', path: '{id}/replace-file/' },
    { key: 'retryOcr', path: '{id}/retry-ocr/' },
    { key: 'validate', path: '{id}/validate/' },
    { key: 'writeOff', path: '{id}/write-off/' },
]

@Injectable({
    providedIn: 'root'
})
export class PurchaseInvoiceService extends ServiceBase {

    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public abandonOcr$(id: number): Observable<PurchaseInvoice> {
        const url = this.routes['abandonOcr'].replace('{id}', id.toString());
        return this._postAction$<PurchaseInvoice>(url);
    }

    public confirmIsInvoice$(id: number): Observable<PurchaseInvoice> {
        const url = this.routes['confirmIsInvoice'].replace('{id}', id.toString());
        return this._postAction$<PurchaseInvoice>(url);
    }

    public proposeAllocations$(id: number): Observable<PurchaseInvoice> {
        const url = this.routes['proposeAllocations'].replace('{id}', id.toString());
        return this._postAction$<PurchaseInvoice>(url);
    }

    public replaceFile$(id: number, attachment: string, attachmentName: string): Observable<PurchaseInvoice> {
        const url = this.routes['replaceFile'].replace('{id}', id.toString());
        return this._postAction$<PurchaseInvoice>(url, { attachment, attachmentName });
    }

    public retryOcr$(id: number): Observable<PurchaseInvoice> {
        const url = this.routes['retryOcr'].replace('{id}', id.toString());
        return this._postAction$<PurchaseInvoice>(url);
    }

    public writeOff(invoice: PurchaseInvoice): void {
        this.writeOff$(invoice).subscribe(() => { });
    }

    public writeOff$(invoice: PurchaseInvoice): Observable<PurchaseInvoice> {
        return this.update$(invoice, {
            url: this.routes.writeOff.replace('{id}', invoice.id.toString())
        });
    }

}
